import { render } from "./PNGIcon.vue?vue&type=template&id=b92aef7c&lang=html"
import script from "./PNGIcon.vue?vue&type=script&lang=js"
export * from "./PNGIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__